import * as Yup from 'yup';

type BankValidationKey = string; // 'sortCode|accountNumber'

interface ValidationRecord {
    success: boolean;
    wasManuallyValidated: boolean;
}

const bankValidationCache = new Map<BankValidationKey, ValidationRecord>();

export function getValidationCacheKey(sortCode: string, accountNumber: string): BankValidationKey {
    return `${sortCode.trim()}|${accountNumber.trim()}`;
}

export function getValidationResult(key: BankValidationKey): ValidationRecord | undefined {
    return bankValidationCache.get(key);
}

export function setValidationResult(key: BankValidationKey, data: ValidationRecord): void {
    bankValidationCache.set(key, data);
}

export const SORT_CODE_REGEX = /^[0-9]{2}-[0-9]{2}-[0-9]{2}$/;
export const SORT_CODE_REGEX_ERROR =
    'Sort code must be in the format XX-XX-XX and contain only digits';
export const ACCOUNT_NUMBER_REGEX = /^[0-9]{8}$/;
export const ACCOUNT_NUMBER_REGEX_ERROR = 'Account number must be 8 digits';

export const SortCodeAccountNumberShape = Yup.object().shape({
    sortCode: Yup.string()
        .matches(SORT_CODE_REGEX, SORT_CODE_REGEX_ERROR)
        .required('Sort code is required'),
    accountNumber: Yup.string()
        .matches(ACCOUNT_NUMBER_REGEX, ACCOUNT_NUMBER_REGEX_ERROR)
        .required('Account number is required'),
});
